import { render, staticRenderFns } from "./LobbySponsors.vue?vue&type=template&id=4fdf2d22&scoped=true&"
import script from "./LobbySponsors.vue?vue&type=script&lang=js&"
export * from "./LobbySponsors.vue?vue&type=script&lang=js&"
import style0 from "./LobbySponsors.vue?vue&type=style&index=0&id=4fdf2d22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdf2d22",
  null
  
)

export default component.exports